export default "__VITE_ASSET__DYWYdd4V__"